import { lazy } from 'react';
import DefaultView from 'components/common/DefaultView';
import ProtectedRoute from 'components/common/ProtectedRoute';
const CustomerSummary = lazy(
  () => import('components/views/dashboard/components/CustomerSummary'),
);
const CampaignSummary = lazy(
  () => import('./components/views/dashboard/components/campaignSummary'),
);
const NotFound = lazy(() => import('components/views/NotFound'));
const Login = lazy(() => import('components/views/login/Login'));

const Dashboard = lazy(() => import('components/views/dashboard'));
const AdminDashboard = lazy(
  () => import('./components/views/dashboard/components/AdminDashboard'),
);
const ControlPanel = lazy(
  () => import('./components/views/dashboard/controlPanel/controlPanel'),
);

export const ROUTE_PATHS = {
  LOGIN: '/login',
  DEFAULT: '/',
  NOT_FOUND: '/404',
  DASHBOARD: '/dashboard',
  ADMIN_DASHBOARD: '/admin',
  CAMPAIGN: '/admin/campaign',
  CUSTOMER: '/admin/customer',
  CONTROL_PANEL: '/control-panel',
};

const routes = [
  {
    path: ROUTE_PATHS.DEFAULT,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Dashboard />
        </DefaultView>
      </ProtectedRoute>
    ),
    children: [{ path: ROUTE_PATHS.DASHBOARD, element: <Dashboard /> }],
  },
  {
    path: ROUTE_PATHS.CAMPAIGN,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <CampaignSummary />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.ADMIN_DASHBOARD,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <AdminDashboard />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.CONTROL_PANEL,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <ControlPanel />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.CUSTOMER,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <CustomerSummary />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  {
    path: ROUTE_PATHS.DASHBOARD,
    element: (
      <ProtectedRoute>
        <DefaultView>
          <Dashboard />
        </DefaultView>
      </ProtectedRoute>
    ),
  },
  { path: ROUTE_PATHS.LOGIN, element: <Login /> },
  { path: ROUTE_PATHS.NOT_FOUND, element: <NotFound /> },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
